import { CSSProperties } from "react";
import { useTimerContext } from "./useTimer";
import { useTimerReader } from "./useTimerReader";

const visuallyHiddenStyle: CSSProperties = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap",
};

/**
 * Wrapping component for useTimer and returns the timer in minutes and seconds.
 * This uses `useTimerContext` internally, which is a context provider for syncing cart timers.
 * Styling is up to parent.
 */
export const Timer = ({
  targetDate, // datetime the timer reaches 0
  announcementPrefix,
  announcementSuffix,
  isCriticalAnnouncementEnabled = true,
  disableLiveAnnouncements = false,
  announcementKey,
}: {
  targetDate: string | Date;
  announcementPrefix?: string;
  announcementSuffix?: string;
  isCriticalAnnouncementEnabled?: boolean;
  disableLiveAnnouncements?: boolean;
  announcementKey?: string;
}): JSX.Element => {
  const { timeRemaining } = useTimerContext(targetDate);

  const { srText, minutes, seconds } = useTimerReader({
    timeRemaining,
    announcementPrefix,
    announcementSuffix,
    isCriticalAnnouncementEnabled,
    disableLiveAnnouncements,
    announcementKey,
  });

  if (timeRemaining <= 0) {
    return <></>;
  }

  return (
    <>
      <span aria-hidden="true">
        {minutes}:{seconds}
      </span>

      {!disableLiveAnnouncements && (
        <span style={visuallyHiddenStyle} aria-live="polite">
          {srText}
        </span>
      )}
    </>
  );
};
